import PropTypes from 'prop-types';

import { PointShape, OrientationShape, TreeNodeDatumShape } from '../propTypes';

export const defaultProps = {
  onNodeToggle: () => {},
  onNodeClick: () => {},
  onNodeMouseOver: () => {},
  onNodeMouseOut: () => {},
};

export const propTypes = {
  data: TreeNodeDatumShape.isRequired,
  position: PointShape.isRequired,
  parent: PropTypes.object, // d3-hierarchy Node
  nodeClassName: PropTypes.string,
  nodeSize: PointShape,
  orientation: OrientationShape.isRequired,
  enableLegacyTransitions: PropTypes.bool,
  transitionDuration: PropTypes.number,
  renderCustomNodeElement: PropTypes.func,
  onNodeToggle: PropTypes.func.isRequired,
  onNodeClick: PropTypes.func.isRequired,
  onNodeMouseOver: PropTypes.func.isRequired,
  onNodeMouseOut: PropTypes.func.isRequired,
  subscriptions: PropTypes.object,
};
